import React, { useState } from "react";

import "./valentine-page.m.css";

const ValentinePage = () => {
  const [hamperOption, setHamperOption] = useState(1);

  const handleBtnClick = () => {
    if (hamperOption === 1) {
      window.open(
        `https://razorpay.com/payment-button/pl_Irq8YjOjVTmXbb/view`,
        "_blank"
      );
    } else {
      window.open(
        `https://razorpay.com/payment-button/pl_IrqAscmWoCAw84/view`,
        "_blank"
      );
    }
  };

  return (
    <section styleName="section">
      <main styleName="hero-section">
        <div>
          <div styleName="hero-title-wrapper">
            <h1 styleName="title">Newslaundry Mystery Hamper</h1>
            <p styleName="border-bottom"></p>
          </div>
          <div styleName="hero-section-content-wrapper">
            <div styleName="hero-section-content">
              <p styleName="description">
                If you’re looking for the perfect gift this Valentine’s Day, try
                out Newslaundry’s Mystery hampers.
              </p>
              <p styleName="description">
                Not only does this add an element of mystery to your gifting
                experience, you also keep reader-supported media alive while
                spreading the word about accurate and independent news.
              </p>
            </div>
            <div styleName="hero-section-img">
              <img
                src="https://images.assettype.com/newslaundry/2022-01/a588d3f1-94d1-4020-a8fd-4ba4d8d0b741/valentines.jpg"
                alt="Valentines Mystery box"
              />
            </div>
          </div>
        </div>
      </main>
      <div styleName="sub-section">
        <div styleName="sub-section-contents">
          <p>
            Each hamper contains Newslaundry merch – such as NL hoodies*, tote
            bags, exciting books, Manjul’s limited edition calendar, and much
            more. The contents are a surprise, and they’ll be worth the cost of
            the hamper itself.
          </p>
          <p>So, choose a hamper and surprise yourself or those around you.</p>
        </div>
        <div styleName="sub-section-form">
          <p styleName="option-heading">Choose a hamper</p>
          <div styleName="option-row">
            <div
              styleName={`option left ${
                hamperOption === 1 ? "selected-option" : "unselected-option"
              }`}
              onClick={() => setHamperOption(1)}
            >
              Hamper #1
            </div>
            <div
              styleName={`option right ${
                hamperOption === 2 ? "selected-option" : "unselected-option"
              }`}
              onClick={() => setHamperOption(2)}
            >
              Hamper #2
            </div>
          </div>
          <p styleName="option-heading">Your hamper will include:</p>
          {hamperOption === 1 ? (
            <ul>
              <li>Four different products from the NL Store</li>
              <li>A book signed by the NL team</li>
            </ul>
          ) : (
            <ul>
              <li>Six different products from the NL Store</li>
              <li>Two books signed by the NL team</li>
              <li>A desk calendar by Manjul</li>
            </ul>
          )}
          <div styleName="cta-row">
            <div styleName="cta-content">
              <div styleName="cta-content-to-pay">To pay</div>
              <div styleName="cta-content-price">
                &#x20B9; {hamperOption === 1 ? "2,500" : "5,000"}
              </div>
            </div>
            <button styleName="cta-pay-btn" onClick={handleBtnClick}>
              Buy Now
            </button>
          </div>
        </div>
      </div>
      <div styleName="items-sub-section">
        <h3 styleName="items-heading">A peek into the hamper</h3>
        <div styleName="item-option-grid">
          <div styleName="item-option">
            <p styleName="item-option-heading">
              Books signed by Newslaundry Team
            </p>
            <img
              loading="lazy"
              src="https://images.assettype.com/newslaundry/2022-02/8303e278-0e47-4369-81be-7ca9e5158462/Book_Twitter_post.jpg"
              alt=""
              style={{ aspectRatio: "16/9" }}
            />
          </div>
          <div styleName="item-option">
            <p styleName="item-option-heading">Desk Calendar by Manjul</p>
            <img
              loading="lazy"
              src="https://images.assettype.com/newslaundry/2022-02/aaf2f71f-4b53-4d62-bde0-a9fb654a2648/IMG_0089.jpg"
              alt=""
              style={{ aspectRatio: "16/9" }}
            />
          </div>
          <div styleName="item-option last">
            <p styleName="item-option-heading">Newslaundry Merchandise</p>
            <div styleName="products-grid">
              <img
                loading="lazy"
                src="https://cdn.shopify.com/s/files/1/0480/0325/2390/products/SoapBox-1_10cefa24-99b9-4d54-9352-5844946d8401.png?v=1605338175"
                alt=""
              />
              <img
                loading="lazy"
                src="https://cdn.shopify.com/s/files/1/0480/0325/2390/products/NaxalMug-Sides_79389f8f-60cb-4459-940a-8ce7b7474cf3.png?v=1606400739"
                alt=""
              />
              <img
                loading="lazy"
                src="https://cdn.shopify.com/s/files/1/0480/0325/2390/products/Bottle-Front_d1dd7f68-53e0-41cf-9199-9489bc3d2168.png?v=1605338424"
                alt=""
              />
              <img
                loading="lazy"
                src="https://cdn.shopify.com/s/files/1/0480/0325/2390/products/ToteBag-Front_cd715edd-e674-4ab0-9c58-5c0b734b8abd.png?v=1605338846"
                alt=""
              />
              <img
                loading="lazy"
                src="https://cdn.shopify.com/s/files/1/0480/0325/2390/products/Candle-withshadow.png?v=1605339027"
                alt=""
              />
              <img
                loading="lazy"
                src="https://cdn.shopify.com/s/files/1/0480/0325/2390/products/asd3_578e67fa-162b-4f8d-8104-b021759e6a13.png?v=1628580393"
                alt=""
              />
              <img
                loading="lazy"
                src="https://cdn.shopify.com/s/files/1/0480/0325/2390/products/shopify-black-mask2.jpg?v=1631534798"
                alt=""
              />
              <img
                loading="lazy"
                src="https://cdn.shopify.com/s/files/1/0480/0325/2390/products/Mug-1.jpg?v=1637326448"
                alt=""
              />
              <img
                loading="lazy"
                src="https://cdn.shopify.com/s/files/1/0480/0325/2390/products/Fridgemagnets.jpg?v=1636627660"
                alt=""
              />
              <img
                loading="lazy"
                src="https://cdn.shopify.com/s/files/1/0480/0325/2390/products/Shopify-hoodie-red.jpg?v=1642506664"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div styleName="terms-sub-section">
        <div styleName="terms-heading">Terms and Conditions:</div>
        <ul styleName="notes-wrapper">
          <li>
            This is a limited period offer from February 5th, 2022 to February
            20th, 2022.
          </li>
          <li>
            *Our hoodies range from M-XL, so put your size preference in the
            payment checkout details section in case your hamper contains one.
          </li>
          <li>Delivery in India only.</li>
          <li>
            If you are based overseas, please share an Indian delivery address
            (of friends/family).
          </li>
          <li>
            Please note, delivery of packages will take at least two to three
            weeks. Thank you for your patience.
          </li>
          <li>
            If you have any queries, please drop an email on{" "}
            <a style={{ color: "#ec2227" }} href="mailto:store@newslaundry.com">
              store@newslaundry.com
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
};

export { ValentinePage };
